import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { FavoritesContext } from "../../../../contexts/favorites";
import _ from "lodash";

const CasinoFavorites = ({ pathName }) => {
    const [{ casino: favorite }] = useContext(FavoritesContext);

    return <li>
        <div className="single-nav-item">
            <Link className="link-view-home-slider" to={`${pathName}/Favorites`}/>
            <p>
               <span className="help-ico-v fav-i">
                   <b className="fav-count">{_.size(favorite)}</b>
               </span>
            </p>
        </div>
    </li>;
}

CasinoFavorites.propTypes = {
    pathName: PropTypes.string
};

export default CasinoFavorites;